import { Box, Button } from "@mui/material";
import theme, { padding } from "../../../theme";
import Text from "../../atoms/text/text";

export type TagButton = {
  name: string;
  id: string;
  action: () => void;
  default?: boolean
};

export const TagButtons = ({
  tagButtons,
  selected,
  setSelected,
  direction,
}: {
  tagButtons: TagButton[];
  selected?: TagButton;
  setSelected: (selected: TagButton) => void;
  direction: "row" | "column";
}) => {
  const handlePress = ({ action, tag }: { action: () => void; tag: TagButton }) => {
    action();
    setSelected(tag);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: direction === "row" ? "column" : "row",
      }}
    >
      <Box
        sx={[

          direction === "column" ? { padding: padding / 5, width: 130, marginTop: "10%" } : { marginLeft: "10%" },
          {
            display: "flex",
            flexDirection: direction,
            alignItems: "flex-start",
          },
        ]}
      >
        {tagButtons?.map((t, index) => (
          <Button
            key={index}
            sx={{
              display: "flex",
              bgcolor: selected?.id === t.id ? "primary.light" : "white",
              height: 25,
              margin: padding / 30,
              borderRadius: 2,
              justifyContent: "start",
              "&:hover": {
                bgcolor: "primary.light",
              },
            }}
            onClick={() => handlePress({ action: () => t.action(), tag: t })}
          >
            <Text fontSize={11} style={{ textAlign: "start" }} key={index}>
              {t.name}
            </Text>
          </Button>
        ))}
      </Box>
      {direction === "column" ? (
        <div
          style={{
            position: "relative",
            paddingRight: "10px",
            paddingLeft: "10px",
          }}
        >
          <div
            style={{
              content: '""',
              position: "absolute",
              top: "5%", // Start the border slightly below the top
              bottom: "5%", // End the border slightly above the bottom
              right: 0, // Align the border to the right
              width: "2px", // Border width
              backgroundColor: theme.palette.background.default, // Border color
            }}
          />
        </div>
      ) : (
        <div
          style={{
            marginTop: padding,
            position: "relative",
            paddingTop: "10px",
            paddingBottom: "10px",
            border: "2px color red"
          }}
        >
          <div
            style={{
              content: '""',
              position: "absolute",
              left: "5%", // Start the border slightly below the top
              right: "5%", // End the border slightly above the bottom
              top: 0, // Align the border to the right
              height: "2px", // Border width
              backgroundColor: theme.palette.background.default, // Border color
            }}
          />
        </div>
      )}
    </Box>
  );
};